<template>
  <div class="w-100">
    <template v-if="$mq==='sm'">
      <div class="d-flex align-items-start justify-content-between mb-3">
        <proa-heading>{{ $t('pages.project.heading') }}</proa-heading>
        <proa-button v-if="signedInUser.creatable" @click.native="$router.push({ name: 'newProject' })">
          {{ $t('common.createProject') }}
        </proa-button>
      </div>
      <div class="d-flex align-items-end justify-content-between mb-2">
        <proa-heading sub>
          {{ $t('pages.project.ongoingProjects') }}
          <span v-if="ongoingProjects.length">（{{ ongoingProjects.length }}）</span>
        </proa-heading>
      </div>
    </template>
    <template v-else>
      <proa-heading>{{ $t('pages.project.heading') }}</proa-heading>
      <div class="d-flex align-items-end justify-content-between mt-3 pt-3 mb-3 pb-1">
        <proa-heading sub>
          {{ $t('pages.project.ongoingProjects') }}
          <span v-if="ongoingProjects.length">（{{ ongoingProjects.length }}）</span>
        </proa-heading>
        <proa-button v-if="signedInUser.creatable" @click.native="$router.push({ name: 'newProject' })">
          {{ $t('common.createProject') }}
        </proa-button>
      </div>
    </template>
    <proa-card
      v-for="ongoingProject in ongoingProjects"
      :key="ongoingProject.id"
      :class="['project-card mb-2', { 'active': activeProjectId == ongoingProject.id }]"
      @mouseover.native="activeProjectId = ongoingProject.id"
      @mouseleave.native="activeProjectId = null"
      @click.native="$router.push({ name: 'showProject', params: { id: ongoingProject.id } })"
    >
      <div class="project-name">{{ ongoingProject.projectName }}</div>
      <div class="users">
        <div class="tooltip-padding" @mouseover.stop="" @mouseleave.stop="" @click.stop=""></div>
        <div class="users-scroll-wrapper">
          <proa-tooltip
            v-for="user in ongoingProject.users"
            :key="user.id"
            class="avatar-wrapper"
          >
            <proa-avatar
              :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
              size="sm"
            />
            <template v-slot:tooltip>
              <div class="avatar-name">
                {{ user.meta.displayName }}
              </div>
            </template>
          </proa-tooltip>
        </div>
      </div>
    </proa-card>
    <div v-if="archivedProjects.length" class="d-flex align-items-end justify-content-between mt-3 pt-3 mb-3 pb-1">
      <proa-heading sub>
        {{ $t('pages.project.archivedProjects') }}
        <span>（{{ archivedProjects.length }}）</span>
      </proa-heading>
    </div>
    <proa-card
      v-for="archivedProject in archivedProjects"
      :key="archivedProject.id"
      :class="['project-card mb-2', { 'active': activeProjectId == archivedProject.id }]"
      @mouseover.native="activeProjectId = archivedProject.id"
      @mouseleave.native="activeProjectId = null"
      @click.native="$router.push({ name: 'showProject', params: { id: archivedProject.id } })"
    >
      <div class="project-name">{{ archivedProject.projectName }}</div>
      <div class="users">
        <div  class="users-scroll-wrapper">
          <div v-for="user in archivedProject.users" :key="user.id" class="avatar-wrapper">
            <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="sm"/>
          </div>
        </div>
      </div>
    </proa-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Project from '@/store/models/Project'
import ProaAvatar from '../../atoms/ProaAvatar.vue'

export default {
    name: "IndexProject",
    computed: {
        archivedProjects: function () {
            return Project.query().where("isArchived", true).get();
        },
        ongoingProjects: function () {
            return Project.query().where("isArchived", false).get();
        },
        ...mapGetters({
            signedInUser: "auth/signedInUser"
        })
    },
    data() {
        return {
            activeProjectId: null
        };
    },
    methods: {
        ...mapActions({
            apiGetProjects: "entities/projects/index"
        })
    },
    async created() {
        await this.apiGetProjects();
    },
    components: { ProaAvatar }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.project-card {
  height: auto;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;

  @include mq(md) {
    flex-direction: row;
    align-items: center;
    height: 80px;
    padding: 0 20px;
  }

  &.active {
    background-color: $light-gray-color;
  }

  .project-name {
    color: $secondary-color;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

    @include mq(md) {
      width: 20%;
    }
  }

  .users {
    flex-grow: 1;
    width: 100%;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include mq(md) {
      padding-bottom: 22px;
      margin-bottom: 16px;

      .tooltip-padding {
        height: 40px;
        background-color: transparent;
        cursor: auto;
      }
    }

    .users-scroll-wrapper {
      display: flex;
      padding-top: 10px;

      @include mq(md) {
        padding: 0 20px;
      }
    }

    .avatar-wrapper {
      margin-right: 5px;
      .avatar-name {
        max-width: 100px;
        font-size: 11px;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
